export const GRID_CONSTANTS = {
  CARD_MIN_WIDTH: '300px',
  HOVER_WIDTH: '320px',
  GRID_TEMPLATE_COLUMNS: 'repeat(auto-fill, minmax(300px, 1fr))',
  GRID_TEMPLATE_COLUMNS_3: 'repeat(3, minmax(0, 1fr))',
  LIST_CARD_MIN_HEIGHT: '100px',
  LIST_HEADER_WIDTH: '80%',
  TRANSITION_DURATION: '0.2s',
  TRANSITION_DURATION_LONG: '0.3s',
  SHADOW_NORMAL: '0 2px 8px rgba(0,0,0,0.1)',
  SHADOW_HOVER: '0 4px 12px rgba(0,0,0,0.15)',
  SHADOW_GRID_HOVER: '0 8px 24px rgba(0,0,0,0.15)',
  BORDER_RADIUS: '16px',
  BORDER_COLOR: '#CACDD5',
  HOVER_TRANSFORM: 'translateY(-4px)',
  HOVER_MAX_HEIGHT: '400px',
};